module.exports = __webpack_public_path__ + "img/VL_14_02.cde2e90b.png";